import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import Navbar from './components/sections/Navbar';
import HeroSection from './components/sections/HeroSection';
import ExperienceOverview from './components/sections/ExperienceOverview';
import EventTypes from './components/sections/EventTypes';
import HowItWorks from './components/sections/HowItWorks';
import SocialProof from './components/sections/SocialProof';
import Gallery from './components/sections/Gallery';
import BookingSection from './components/sections/BookingSection';
import FinalCTA from './components/sections/FinalCTA';
import Footer from './components/sections/Footer';

const LumaPage = () => (
  <div style={{ background: '#0A0A0A', minHeight: '100vh' }}>
    <Navbar />
    <HeroSection />
    <ExperienceOverview />
    <EventTypes />
    <HowItWorks />
    <SocialProof />
    <Gallery />
    <BookingSection />
    <FinalCTA />
    <Footer />
  </div>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LumaPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="top-right"
        toastOptions={{
          style: {
            background: '#111111',
            border: '1px solid rgba(139,92,246,0.3)',
            color: '#ffffff',
            fontFamily: 'Manrope, sans-serif',
          },
        }}
      />
    </div>
  );
}

export default App;
